module.exports = __webpack_public_path__ + "static/img/default3.ba007a58.png";